import { render, staticRenderFns } from "./professionalArticles.vue?vue&type=template&id=0c2b9e2e&scoped=true&"
import script from "./professionalArticles.vue?vue&type=script&lang=js&"
export * from "./professionalArticles.vue?vue&type=script&lang=js&"
import style0 from "./professionalArticles.vue?vue&type=style&index=0&id=0c2b9e2e&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2b9e2e",
  null
  
)

export default component.exports